import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Message } from 'semantic-ui-react';

interface SendContractEmailModalProps {
  open: boolean;
  onClose: () => void;
  onSend: (email: string) => Promise<void>;
  defaultEmail?: string;
  contractId?: string;
}

export const SendContractEmailModal: React.FC<SendContractEmailModalProps> = ({
  open,
  onClose,
  onSend,
  defaultEmail = '',
}) => {
  const [email, setEmail] = useState(defaultEmail);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setEmail(defaultEmail);
      setError(null);
    }
  }, [open, defaultEmail]);

  const handleSubmit = async () => {
    setError(null);

    // Validação básica de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setError('Por favor, insira um email válido.');
      return;
    }

    setLoading(true);
    try {
      await onSend(email);
      handleClose();
    } catch (err: any) {
      setError(err.message || 'Erro ao enviar email. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail(defaultEmail);
    setError(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} size="small">
      <Modal.Header>Enviar Dados do Contrato por Email</Modal.Header>
      <Modal.Content>
        {error && (
          <Message negative>
            <Message.Header>Erro</Message.Header>
            <p>{error}</p>
          </Message>
        )}
        
        <Form>
          <Form.Field>
            <label>Email Destinatário</label>
            <input
              type="email"
              placeholder="exemplo@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
            <small style={{ color: '#666', display: 'block', marginTop: '0.5rem' }}>
              Digite o email para onde deseja enviar os dados do contrato formatados para VTME.
            </small>
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button primary onClick={handleSubmit} loading={loading}>
          Enviar Email
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
